export default "__VITE_ASSET__78cb4066__"